import * as React from 'react';

type VariantComponentProps = {
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  NewComponent: React.ComponentType<any>;
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  OldComponent: React.ComponentType<any>;
  shouldRenderNewComponent: boolean;
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  [key: string]: any;
};

const VariantComponent = React.memo<VariantComponentProps>(
  ({
    shouldRenderNewComponent,
    NewComponent,
    OldComponent,
    ...props
  }: VariantComponentProps) => {
    return shouldRenderNewComponent ? (
      <NewComponent {...props} />
    ) : (
      <OldComponent {...props} />
    );
  },
);

export default VariantComponent;
